import { combineReducers } from 'redux'
import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux'
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Actions
import auth, { actions as Auth } from './auth'
import lead, { actions as Lead } from './lead'
import lookup, { actions as Lookup } from './lookup'
import notification, { actions as Notification } from './notification'
import reminder, { actions as Reminder } from './reminder'
import response, { actions as Response } from './response'
import settings, { actions as Settings } from './settings'
import user, { actions as User } from './user'
import liveCall, { actions as LiveCall } from './live-call'

import { report } from '../modules/Charts/combined-slice'

const reducer = combineReducers({
  auth,
  lead,
  lookup,
  notification,
  reminder,
  response,
  settings,
  user,
  report,
  liveCall,
})

const persistConfig = {
  key: process.env.REACT_APP_VERSION ?? 'default',
  version: 1,
  storage,
  whitelist: ['user'],
}

const persistedReducer = persistReducer(persistConfig, reducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
  devTools: process.env.NODE_ENV === 'development',
})

export default store

export const persistor = persistStore(store)

/* Export store actions */
export { Auth, Lead, Lookup, Notification, Reminder, Response, Settings, User, LiveCall }

/* Export typings */
export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector
